import React from 'react';
import P from 'bluebird';
import styled from 'styled-components';

import Button from '../Button';
import modalContent from './modalContent';
import { useStore } from '../../context/appContext';
import Icons from './Icons';

const Wrapper = styled.div`
  height: 100%;
  width: 80%;
`;

const IconContainer = styled.div`
  width: 100%;
  text-align: center;
  padding-bottom: 0.3rem;
`;

const Header = styled.h4`
  font-size: 1rem;
  text-align: center;
  padding-bottom: 0.5rem;
`;

const Text = styled.p`
  font-size: 0.8rem;
  text-align: center;
  padding-bottom: 1rem;
`;

const AdditionalText = styled.p`
  margin-top: -.5rem;
  font-size: 0.8rem;
  text-align: center;
  padding-bottom: 1rem;
`;
const List = styled.ul`
  margin-top: 0.1rem;
  padding-bottom: 1rem;
`;

const ListText = styled.li`
  font-size: 0.8rem;
  list-style: none;
  padding: 0 .5rem 1rem 0;
`;

function GenericModal({ modalType, extraMessage }) {
  const { setModal, stepForward, stepBackwards } = useStore();

  const closeModal = () =>
    setModal({
      open: false,
      type: modalType,
    });

  const handleButton = () => {
    const action = modalContent[modalType].button.action;
    if (modalType === 6){
      stepBackwards();
      return closeModal();
    }
    switch (action) {
      case 'none':
        break;
      case 'retry':
        return closeModal();
      case 'next':
        return P.bind(this)
          .then(() => stepForward())
          .then(() => closeModal());

      case 'close':
        return closeModal();
      default:
        break;
    }
  };

  return (
    <Wrapper>
      <IconContainer>
        <Icons icon={modalContent[modalType].icon} />
      </IconContainer>
      <Header>{modalContent[modalType].header}</Header>
      <Text>{modalContent[modalType].text}</Text>
      <AdditionalText>{extraMessage}</AdditionalText>
      {modalContent[modalType].list &&
        <List>
          {
            modalContent[modalType].list.map(text =>
              <ListText>
                <Icons icon={'CheckList'} />
                {text}
              </ListText>
            )
          }
        </List>
      }
      <Button filled onClick={handleButton}>
        {modalContent[modalType].button.text}
      </Button>
    </Wrapper >
  );
}

export default GenericModal;
